export default __webpack_public_path__ + "static/media/coin5.d8193998.png";